import trim from 'validator/lib/trim'
import isInt from 'validator/lib/isInt'
import email from 'validator/lib/isEmail'

// check if the item is required it must be not null and not empty
export const required = (val) => val && trim(val).length // !isNull(trim(val + ''))

// must be required, not empty, must be an integer
export const intRequired = (val) => isInt(val + '') && val !== 0
export const int = (val) => isInt(val + '')
// export const number = (val) => !isNaN(Number(val)) && !isNull(trim(val))
export const isEmail = (val) => email(val)


// WEBPACK FOOTER //
// ./src/utils/validators.js